<template>
  <router-view></router-view>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("fetchUser");
  }
}
</script>

<style lang="scss">
.logo {
  color: #32325d;
  font-size: 26px;
}
.logo.white {
  color: #fff;
}
.el-dialog {
  border-radius: 7px;
  &__header {
    padding: 25px 25px 15px;
  }
  &__body {
    padding: 10px 15px 25px 25px;
  }
  &__title {
    font-size: 22px;
    padding-bottom: 0.5rem;
    font-weight: 600;
    color: #32325d;
  }
}
.myform .form-group {
  margin-bottom: 0.7rem;
}
.myform2 .form-group {
  margin-bottom: 0rem;
  width: 200px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none!important;
    margin: 0!important; /* <-- Apparently some margin are still there even though it's hidden */
}

@media only screen and (max-width: 600px) {
  .el-table__body, .el-table__header {
    width: 1100px!important;
  }
}
</style>
